import styled from 'styled-components/macro';
import { baseSpacing, colors, radius } from 'css/constants';

export const OptionItem = styled.div`
  display: flex;
  width: 100%;
  justify-content: space-between;
  align-items: center;

  & > span {
    margin-right: ${baseSpacing / 4}px;
  }

  & > span:last-child {
    margin-right: 0;
  }
`;

export const CardOptionItem = styled(OptionItem)`
  justify-content: flex-start;

  & > span:last-child {
    margin-left: auto;
  }
`;

export const Last4Wrapper = styled.div`
  display: flex;
  align-items: center;
  margin-right: ${baseSpacing / 4}px;

  & > span:first-child {
    font-size: 0.5rem;
  }
`;

export const OrderSummary = styled.div`
  display: flex;
  flex-grow: 1;
  color: #fff;
  margin-bottom: 0;
  padding: ${baseSpacing / 2}px;
  border-radius: ${radius}px;
  background-color: ${colors.darkBlue};

  & > div {
    flex-grow: 1;
  }

  ul {
    list-style: none;
    margin: 0;
    padding: 0;
    width: 100%;

    li {
      display: flex;
      justify-content: space-between;
    }

    li:last-child {
      margin-top: ${baseSpacing / 4}px;
      padding-top: ${baseSpacing / 4}px;
      border-top: 1px solid rgb(255 255 255 / 33%);
      text-transform: uppercase;
    }
  }

  p {
    margin: 0;
  }

  h2 {
    font-size: 1.25rem;
    line-height: 1.25;
    font-weight: normal;
    margin-bottom: ${baseSpacing / 2}px;
  }
`;
